import { z } from "zod";

export const sendPhotoRouletteTapSchema = z.object({
	target_user_id: z.string().min(1),
});

export type SendPhotoRouletteTapPayload = z.infer<typeof sendPhotoRouletteTapSchema>;
